// 해당 값이 변동이 있을시 공유 필요(SP1)
export const defaultAllCategory = { key: "All", value: "" };
export const getCategoryCode = [
  { key: "Recommended", value: "6458f16991b315a609781eb3" },
  { key: "Gacha", value: "646fa1cadb9fff789a946348" },
];
